import { Skeleton } from '@/components/ui/skeleton'

export const MessagesSkeleton = () => (
  <>
    <Skeleton className="mb-5 h-12 w-full rounded-none rounded-bl-[8px] rounded-br-[8px] rounded-tr-[8px] lg:w-[60%]" />
    <Skeleton className="mb-5 h-20 w-full rounded-none rounded-bl-[8px] rounded-br-[8px] rounded-tr-[8px] lg:w-[60%]" />
    <div className="mb-5 flex w-full justify-end">
      <Skeleton className="h-12 w-full rounded-none rounded-bl-[8px] rounded-br-[8px] rounded-tl-[8px] lg:w-[60%]" />
    </div>
    <Skeleton className="mb-5 h-12 w-full rounded-none rounded-bl-[8px] rounded-br-[8px] rounded-tr-[8px] lg:w-[60%]" />
    <div className="flex w-full justify-end">
      <Skeleton className="h-12 w-full rounded-none rounded-bl-[8px] rounded-br-[8px] rounded-tl-[8px] lg:w-[60%]" />
    </div>
  </>
)
